import React, { useState, useEffect, useRef } from 'react'
import Layout from '../../../brands/components/Layout'
import SelectField from '../../../../components/Form/Select'
import { IMG_URL } from '../../../../config'
import { Icon } from '@iconify/react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAppDispatch } from '../../../../redux/hook'
import { HIDE_LOADER, SHOW_LOADER } from '../../../../redux/slices/LoaderSlice'
import { getLocations } from '../../../userslisting/createuser/api'
import { getAssignedUsers, delAssignUser, assignForm } from '../../api'
import { User } from '../types'
import { getLocBasedUsers } from '../../../resources/api'
import Select from 'react-select'
import { MultiValue } from '../../../resources/assignuser/components/Badge'
import { SHOW_NOTIFICATION } from '../../../../redux/slices/showNotificationSlice'
import { Button } from 'react-bootstrap'

const AssignUsers: React.FC = () => {
    const [empchecked, empSetChecked] = useState<string>('allemp')
    const [isAllEmployee, setempIsAllEmployyee] = useState<boolean>(true)
    const [locations, setLocations] = useState<
        { label: string; value: string }[]
    >([])
    const [locUsers, setLocUsers] = useState<
        { label: string; value: string }[]
    >([])
    const [assignedUsers, setAssignedUsers] = useState<User[]>([])
    const [userlocation, setUserLocation] = useState<string>('')

    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const location = useLocation()
    const { id, formName } = location.state

    const selectRef = useRef<any>(null)
    const [selectedEmployees, setSelectedEmployees] = useState<User[]>([])
    const [isdisabled, setDisabled] = useState<boolean>(false)
    const [resetSelectKey, setResetSelectKey] = useState<number>(0)
    // Function to reset the Select component
    const getLookUpData = async () => {
        try {
            const response = await getLocations()
            const transformedLocations = response?.data?.data?.map(
                (location: any) => ({
                    value: location.id,
                    label: location.name,
                })
            )
            setLocations(transformedLocations)
            dispatch(HIDE_LOADER())
        } catch (err) {
            // Handle any errors here
            console.error('Error fetching:', err)
            dispatch(HIDE_LOADER())
        }
    }
    const getusers = async () => {
        if (empchecked !== 'allemp') {
            try {
                const response = await getAssignedUsers(id)
                setAssignedUsers(
                    response?.data?.map((user: User) => ({
                        ...user,
                        isLocal: false,
                    }))
                )
                dispatch(HIDE_LOADER())
            } catch (err) {
                // Handle any errors here
                console.error('Error fetching:', err)
                dispatch(HIDE_LOADER())
            }
        }
    }
    const getLocUsers = async (locationID: string) => {
        try {
            dispatch(SHOW_LOADER())
            const response = await getLocBasedUsers(locationID)
            const transformedusers = response?.data?.map((user: any) => ({
                ...user,
                value: user.id,
                label: user.firstName + ' ' + user.lastName,
                isLocal: true,
            }))
            setLocUsers(transformedusers)
            dispatch(HIDE_LOADER())
        } catch (err) {
            // Handle any errors here
            console.error('Error fetching:', err)
            dispatch(HIDE_LOADER())
        }
    }
    const addEmployees = (selectedValues: any) => {
        if (!selectedValues) {
            setSelectedEmployees([])
            return
        }
        const selectAllClicked =
            selectedValues[selectedValues.length - 1]?.value === 'all'
        if (selectAllClicked) {
            // if select all is clicked
            const newOptionsToSelect: any[] = locUsers.filter(
                (option) =>
                    !selectedEmployees.some(
                        (selected) => selected.value === option.value
                    )
            )
            // Combine already selected with new selections
            setSelectedEmployees((prev) => [...prev, ...newOptionsToSelect])
        } else {
            //   selectedValues.length === 0 && selectedEmployees.length === 0) // do nothing
            if (selectedValues?.length < selectedEmployees?.length) {
                // if user enter backpress to remove element in react-select
                const removedItem = selectedEmployees.filter(
                    (prevSelected) =>
                        !selectedValues.some(
                            (item: { id: string }) =>
                                item.id === prevSelected.id
                        )
                )
                setAssignedUsers((prev) =>
                    prev.filter(
                        (user: User) =>
                            user.id !== removedItem[0].id &&
                            removedItem[0].isLocal === true
                    )
                )
            }
            setSelectedEmployees(selectedValues)
        }
    }
    const deleteAssignUsers = async (userid: string[], isEmpty: boolean) => {
        dispatch(SHOW_LOADER())
        try {
            const response = await delAssignUser(id, userid)
            if (response.status === 200) {
                setDisabled(false)
                dispatch(HIDE_LOADER())
                !isEmpty && setAssignedUsers([])
                !isEmpty && setUserLocation('')
                !isEmpty && setSelectedEmployees([])
                setResetSelectKey((prevKey) => prevKey + 1)
            }
        } catch (err) {
            console.error('Error', err)
        }
    }
    const clearAll = () => {
        deleteAssignUsers(
            assignedUsers.map((obj: User) => obj.id),
            false
        )
    }
    const assignuser = async () => {
        if ((!isAllEmployee && assignedUsers.length > 0) || isAllEmployee) {
            dispatch(SHOW_LOADER())
            const arrayOfIds = assignedUsers.map((obj: User) => obj.id)
            const payload = {
                formId: id,
                isAllEmployees: isAllEmployee,
                userIds: !isAllEmployee ? arrayOfIds : null,
            }
            try {
                const response = await assignForm(payload)
                if (response.status === 200) {
                    dispatch(HIDE_LOADER())
                    empSetChecked('allemp')
                    setempIsAllEmployyee(true)
                    navigate('/forms')
                    dispatch(
                        SHOW_NOTIFICATION({
                            type: 'success',
                            message: 'From assigned',
                        })
                    )
                }
            } catch (err) {
                dispatch(HIDE_LOADER())
                console.error('Error fetching...', err)
            }
        }
    }

    useEffect(() => {
        const updatedAssignedUsers = [...assignedUsers] // Create a copy of assignedUsers to avoid mutating state directly

        selectedEmployees.forEach((selectedUser: any) => {
            // Check if the selected user's id exists in the assignedUsers array
            const exists = updatedAssignedUsers.some(
                (assignedUser: any) => assignedUser.id === selectedUser.id
            )

            // If the selected user's id doesn't exist in the assignedUsers array, push it into the array
            if (!exists) {
                updatedAssignedUsers.push(selectedUser)
            }
        })
        setAssignedUsers(updatedAssignedUsers)
    }, [selectedEmployees])

    useEffect(() => {
        if (empchecked !== 'allemp') {
            dispatch(SHOW_LOADER())
            getLookUpData()
            getusers()
        }
    }, [empchecked])

    const customStyles = {
        control: (provided: any) => ({
            ...provided,
            padding: '.375rem 0.60rem .375rem .35rem',
        }),
        multiValueRemove: () => ({
            display: 'none', // Hide the remove icon
        }),
        clearIndicator: () => ({
            display: 'none', // Hide the clear indicator
        }),
        indicatorSeparator: () => ({
            display: 'none', // Hide the clear indicator
        }),
        dropdownIndicator: () => ({
            color: '#000',
            fontSize: '3px',
            // marginRight: '4px',
        }),
    }

    const employeeOptions = () => {
        if (locUsers.length !== selectedEmployees.length) {
            assignedUsers.filter((user: User) => {
                user.id
            })
            return [{ value: 'all', label: 'All' }, ...locUsers]
        }
        return []
    }

    const userRemoveIconClick = async (user: User) => {
        !user.isLocal && dispatch(SHOW_LOADER())
        setDisabled(!isdisabled)
        const removedUsers = assignedUsers.filter((users: User) => {
            return users.id !== user.id // Return the result of the comparison
        })
        setSelectedEmployees((prev) =>
            prev.filter((users: User) => users.id !== user.id)
        )
        setAssignedUsers(removedUsers)
        !user.isLocal && deleteAssignUsers([user.id], true)
    }

    return (
        <div>
            <Layout>
                <div className="">
                    <div className=" sync mb-3">
                        <h4>{formName}</h4>
                        <label>
                            Select the employees you want to assign this form
                        </label>
                    </div>
                    <div className="upload-form">
                        <div className="sync-form">
                            <form>
                                <div className="row mrg-top">
                                    <div className="col-sm-6 emp-rad-list">
                                        <li className="emp-rad">
                                            <input
                                                type="radio"
                                                id="emp-selection"
                                                name="fav_language"
                                                value="allemp"
                                                defaultChecked
                                                onChange={(
                                                    e: React.ChangeEvent<HTMLInputElement>
                                                ) => {
                                                    empSetChecked(
                                                        e.target.value
                                                    )
                                                    setempIsAllEmployyee(
                                                        !isAllEmployee
                                                    )
                                                }}
                                            />
                                            <label htmlFor="html">
                                                All employees
                                            </label>
                                        </li>
                                        <li className="emp-rad">
                                            <input
                                                type="radio"
                                                id="emp-selection"
                                                name="fav_language"
                                                value="indemp"
                                                onChange={(
                                                    e: React.ChangeEvent<HTMLInputElement>
                                                ) => {
                                                    empSetChecked(
                                                        e.target.value
                                                    )
                                                    setempIsAllEmployyee(
                                                        !isAllEmployee
                                                    )
                                                }}
                                            />
                                            <label htmlFor="html">
                                                Select employees
                                            </label>
                                        </li>
                                    </div>
                                </div>
                                {empchecked !== 'allemp' && (
                                    <div>
                                        <div className="row mrg-top">
                                            <div className="col-sm-6">
                                                <SelectField
                                                    name="location"
                                                    label="By Location"
                                                    options={[
                                                        {
                                                            value: '',
                                                            label: 'Select Location',
                                                        },
                                                        ...locations,
                                                    ]}
                                                    value={userlocation}
                                                    defaultValue={
                                                        'Select Location'
                                                    } // Explicitly set default to null
                                                    onChange={(e: any) => {
                                                        setUserLocation(
                                                            e.target.value
                                                        )
                                                        if (
                                                            e.target.value !==
                                                            ''
                                                        ) {
                                                            getLocUsers(
                                                                e.target.value
                                                            )
                                                        }

                                                        if (
                                                            e.target.value ===
                                                            ''
                                                        ) {
                                                            setLocUsers([])
                                                        }
                                                    }}
                                                    onBlur={() => {
                                                        return
                                                    }}
                                                    error={''}
                                                    touched={true}
                                                />
                                            </div>
                                        </div>

                                        <div className="row mrg-top">
                                            <div className="col-sm-6">
                                                <label>By Employee</label>
                                                <Select
                                                    key={resetSelectKey} // Add key to trigger reset when key changes
                                                    ref={selectRef}
                                                    isDisabled={
                                                        userlocation === ''
                                                    }
                                                    className="mt-2"
                                                    isMulti
                                                    options={
                                                        employeeOptions() as User[]
                                                    }
                                                    value={
                                                        selectedEmployees.length ===
                                                        locUsers.length
                                                            ? (locUsers as User[])
                                                            : (selectedEmployees as User[])
                                                    }
                                                    onChange={addEmployees}
                                                    styles={customStyles}
                                                    placeholder="Add Employee"
                                                    components={{
                                                        MultiValue,
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        <div className="row mrg-top mt-4">
                                            <div className="emp-list mb-3">
                                                <span>
                                                    Selected Employees (
                                                    {assignedUsers.length})
                                                </span>
                                                <span
                                                    onClick={
                                                        assignedUsers.length ===
                                                        0
                                                            ? void 0
                                                            : clearAll
                                                    }
                                                    className={
                                                        assignedUsers.length ===
                                                        0
                                                            ? 'disabled'
                                                            : ''
                                                    }
                                                >
                                                    Clear All
                                                </span>
                                            </div>

                                            <div className="emp-group">
                                                <ul>
                                                    {assignedUsers.map(
                                                        (user: User, index) => (
                                                            <>
                                                                <li key={index}>
                                                                    {user.imageUrl ===
                                                                    null ? (
                                                                        <Icon
                                                                            icon="mdi:user"
                                                                            height={
                                                                                '48px'
                                                                            }
                                                                            width={
                                                                                '48px'
                                                                            }
                                                                        />
                                                                    ) : (
                                                                        <img
                                                                            height={
                                                                                '48px'
                                                                            }
                                                                            width={
                                                                                '48px'
                                                                            }
                                                                            style={{
                                                                                borderRadius:
                                                                                    '50%',
                                                                            }}
                                                                            src={`${IMG_URL}${user.imageUrl}`}
                                                                        />
                                                                    )}

                                                                    <label>
                                                                        {
                                                                            user.firstName
                                                                        }{' '}
                                                                        {
                                                                            user.lastName
                                                                        }
                                                                    </label>
                                                                    <Icon
                                                                        icon="mdi:close"
                                                                        cursor={
                                                                            'pointer'
                                                                        }
                                                                        onClick={() =>
                                                                            userRemoveIconClick(
                                                                                user
                                                                            )
                                                                        }
                                                                    />
                                                                </li>
                                                            </>
                                                        )
                                                    )}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <div className="row mt-4 mb-4">
                                    <div className="col-sm-6 button-block">
                                        <Button
                                            className="button button-primary me-5"
                                            variant="success"
                                            disabled={
                                                empchecked !== 'allemp' &&
                                                assignedUsers.every(
                                                    (user: User) =>
                                                        user.isLocal === false
                                                )
                                            }
                                            onClick={assignuser}
                                        >
                                            SAVE
                                        </Button>
                                        <a
                                            className="button button-outline"
                                            onClick={() => navigate('/forms')}
                                        >
                                            CANCEL
                                        </a>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </Layout>
        </div>
    )
}

export default AssignUsers
